import { buildStepNarration } from './stepNarrationCopy.js'
import { DESIGN_DNA_MOODBOARD_URL } from './designDnaDemoContent.part01.js'

export const DESIGN_DNA_AI_LOG_STEPS = [
  {
    durationMs: 2800,
    actionName: 'Fetched moodboard',
    arguments: { url: DESIGN_DNA_MOODBOARD_URL, pins: 13 },
    result: { ok: true, board: 'WebApp UI Inspirations' },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Pinterest moodboard ingested — 13 dashboard and SaaS UI references indexed',
      'classifying layout, visual, and UX signals',
      0,
    ),
  },
  {
    durationMs: 4200,
    actionName: 'Classified references',
    arguments: { layers: ['layout', 'visual', 'ux'] },
    result: { dashboard: '42%', aiWorkspace: '28%', analytics: '18%' },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Reference mix classified — enterprise dashboard patterns dominate',
      'extracting recurring visual signals',
      1,
    ),
  },
  {
    durationMs: 5600,
    actionName: 'Extracted Design DNA',
    arguments: { phases: 13, signals: 12 },
    result: { accepted: 8, rejected: 3 },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Dominant patterns separated from noise — dark theme + blue accent system locked',
      'generating design tokens and MUI mapping',
      2,
    ),
  },
  {
    durationMs: 7200,
    actionName: 'Mapped MUI theme',
    arguments: { library: '@mui/material', version: 'latest' },
    result: { shapeOverrides: true, paletteOverrides: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'MUI transformation rules applied — shape, elevation, and palette overrides ready',
      'writing the internal processing report',
      3,
    ),
  },
  {
    durationMs: 4800,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: '/design-system/design-dna-extraction-engine.md',
      content: '# AI Design DNA Extraction Engine\n...',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Full 13-phase Design DNA report written to the artifact panel',
      'building the Next.js MUI component showcase',
      4,
    ),
  },
]
